module.exports = __webpack_public_path__ + "media/packs/images/flags/SR-e4bfa73138c427bdde4cba00e590502c.svg";